import React from 'react';
import { FormControl, FormErrorMessage, FormLabel } from '@chakra-ui/react';
import { FormFeedback } from '../form-feedback';
export const FormField = (props)=>{
    const { children , error , isInvalid , name , isRequired , label , ...formControlProps } = props;
    return /*#__PURE__*/ React.createElement(FormControl, {
        isInvalid: isInvalid,
        isRequired: isRequired,
        ...formControlProps
    }, label && /*#__PURE__*/ React.createElement(FormLabel, {
        htmlFor: name,
        mb: 1
    }, label), children, /*#__PURE__*/ React.createElement(FormErrorMessage, {
        mt: 1
    }, /*#__PURE__*/ React.createElement(FormFeedback, {
        message: error,
        status: "error"
    })));
};

//# sourceMappingURL=form-field.js.map